module.exports = __webpack_public_path__ + "static/media/STV.dc91f9ad.webp";